<template>
	<div>
		<form-sidebar>
			<v-form method="post" @submit.prevent="submitForm">
				<v-layout wrap>
					<v-flex xs12 pb-3>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Código"
							required
							v-model="$v.model.code.$model"
							:error="$v.model.code.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 pb-3>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Url Web"
							required
							v-model="$v.model.codeWeb.$model"
							:error="$v.model.codeWeb.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 pb-3>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Fragment Móvil"
							type="number"
							v-model.number="model.numFragment"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 pb-3>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Posición"
							type="number"
							v-model="$v.model.position.$model"
							:error="$v.model.position.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 pb-3>
						<v-combobox
							background-color="white"
							box
							small-chips
							class="body-1"
							clearable
							hide-details
							label="Teclas de acceso rápido"
							multiple
							v-model="model.hotKeys"
						>
							<template slot="selection" slot-scope="{ item }">
								<v-chip
									close
									small
									@input="removeKey(item)"
								>
									<strong>{{ item }}</strong>&nbsp;
								</v-chip>
							</template>
						</v-combobox>
					</v-flex>
					<v-flex xs12 pb-3>
						<v-layout
							wrap
							v-for="(language, index) in model.languages"
							:key="language.id"
						>
							<v-flex xs3 sm1>
								<label for="language">{{ index }}</label>
							</v-flex>
							<v-flex xs9 sm11>
								<v-layout wrap>
									<v-flex xs12 pb-3>
										<v-text-field
											background-color="white"
											box
											class="body-1"
											hide-details
											label="Nombre"
											v-model="language.name"
										>
										</v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-textarea
											background-color="white"
											box
											class="body-1"
											height="80"
											hide-details
											label="Descripción"
											no-resize
											v-model="language.description"
										>
										</v-textarea>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											background-color="white"
											box
											class="body-1"
											hide-details
											label="Link de video"
											v-model="language.link"
										>
										</v-text-field>
									</v-flex>
									<v-flex xs12 d-flex>
										<upload-image 
											label-ref="up"
											:label-for="`${index}-manual`"
											:input-id="`${index}-manual`"
											button-title="Cargar archivo"
											@send-file="getManual($event, index)"
										/>
										<div>
											<v-text-field
												solo
												hide-details
												clearable
												readonly
												v-for="(manual, indexMan) in language.manuals"
												:key="indexMan"
												class="body-1 mx-2 mt-0"
												height="30px"
												v-model="manual.file"
												@click:clear="updateManuals(index, indexMan)"
											/>
										</div>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs12 pb-3>
						<v-layout wrap align-center>
							<upload-image 
								label-ref="up"
								label-for="image"
								input-id="image"
								@send-image="getImage"
							/>
							<v-text-field
								solo
								class="body-1 mx-2 mt-0"
								height="30px"
								hide-details
								required
								label="Icono"
								v-model="$v.model.pathIcon.$model"
								:error="$v.model.pathIcon.$error"
							>
							</v-text-field>
						</v-layout>
					</v-flex>
				</v-layout>
				<v-layout wrap row justify-space-between>
					<v-flex xs5 py-0>
						<label class="body-2">Agregar etiqueta</label>
					</v-flex>
					<v-flex xs2 py-0>
						<v-switch
							class="mt-0"
							color="base"
							hide-details
							:label="flagNewName"
							v-model="model.flagNew"
						/>
					</v-flex>
					<v-flex xs12 caption py-0>
						<span>Se mostrará junto al nombre de la acción (Ej.: Nuevo, Beta, etc...)</span>
					</v-flex>
				</v-layout>
				<v-layout v-if="model.flagNew" row wrap>
					<v-flex
						xs12
						v-for="(language, lanKey) in languagesByProject"
						:key="lanKey"
					>
						<label>{{ language.name }}:</label>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							required
							v-model="model.newTitle[lanKey].title"
						></v-text-field>
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						:is-loading="buttonDisabled"
						:on-run-service="loading"
						@accept-button-clicked="submitForm"
						@cancel-button-clicked="closeModal"
					>
					</modal-sidebar-button>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators';
import helper from '@/shared/helper';
import lib from '@/lib';
import UploadImage from '@/components/shared/upload-image';

const PAGE_ACTION_LIST = 'page-action';

const { removeItemFromArrayByIndex } = lib;
const { getLocalData } = helper;

async function created() {
	this.languagesByProject = getLocalData('project-languages');
	const languagesKeys = Object.keys(this.languagesByProject);
	this.newTitle = languagesKeys.reduce((a, k) => {
		const newA = { ...a };
		newA[k] = { title: '' };
		return newA;
	}, {});
	if (this.mode === 'edit') {
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		const { data: record } = await this.$http.get(`action-bar/${this.actionId}`,
			{ headers });
		if (record.data) {
			if (record.data.flagNew && !record.data.newTitle) {
				const newTitleKeys = Object.keys(this.newTitle);
				newTitleKeys.forEach((k) => {
					const text = k === 'es' ? 'Nuevo' : 'New';
					const kTitle = { title: text };
					this.$set(this.newTitle, k, kTitle);
				});
				record.data.newTitle = { ...this.newTitle };
			}
			this.model = {
				code: record.data.code,
				codeWeb: record.data.codeWeb,
				flagNew: record.data.flagNew,
				hotKeys: record.data.hotKeys,
				languages: record.data.languages,
				newTitle: record.data.newTitle || { ...this.newTitle },
				numFragment: record.data.numFragment,
				pathIcon: record.data.pathIcon,
				position: record.data.position,
			};
			this.verifyManualsExist();
		}
	} else {
		this.loadLanguages();
		this.model.pathIcon = `https:${this.getImageUrl('icon-action.svg')}`;
		this.model.newTitle = { ...this.newTitle };
	}
	this.model.codeProject = this.codeProject;
}

function verifyManualsExist() {
	Object.keys(this.model.languages).forEach((key) => {
		if (!this.model.languages[key].manuals) {
			this.$set(this.model.languages[key], 'manuals', []);
		}
	});
}

function buttonDisabled() {
	return this.$v.$invalid || this.languagesEmpty || this.loading;
}

function closeModal() {
	this.goTo(PAGE_ACTION_LIST);
}

function getImage({ urlImage }) {
	this.model.pathIcon = urlImage;
}

function flagNewName() {
	return this.model.flagNew ? 'Sí' : 'No';
}

function languagesEmpty() {
	let disabled = true;
	Object.keys(this.model.languages).forEach((key) => {
		if (this.model.languages[key].name
			&& this.model.languages[key].description) {
			disabled = false;
		}
	});
	return disabled;
}

async function loadLanguages() {
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};
	try {
		const { data: project } = await this.$http.get(`projects/${this.codeProject}`, { headers });
		const projectLanguages = project.data.languages;
		const lang = {};
		Object.keys(projectLanguages).forEach((pLangKey) => {
			if (projectLanguages[pLangKey].isSelected) {
				lang[pLangKey] = {
					id: projectLanguages[pLangKey].id,
					name: '',
					description: '',
					link: '',
					manuals: [],
				};
			}
		});
		const modelLanguages = Object.keys(this.model.languages);
		if (modelLanguages.length === 0) {
			this.model.languages = { ...lang };
		}
	} catch (err) {
		this.showError();
	}
}

function mode() {
	return this.actionId ? 'edit' : 'create';
}

function removeKey(item) {
	const index = this.model.hotKeys.indexOf(item);
	if (index > -1) {
		this.model.hotKeys.splice(index, 1);
	}
}

async function submitForm() {
	const method = this.mode === 'create' ? 'post' : 'put';
	const url = this.mode === 'create' ? 'action-bar' : `action-bar/${this.actionId}`;
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};
	this.loading = true;
	try {
		await this.$http[method](url, this.model, { headers });
		this.goTo(PAGE_ACTION_LIST);
	} finally {
		this.loading = false;
	}
}

function getManual(man, index) {
	this.model.languages[index].manuals = this.model.languages[index].manuals.concat(man);
}

function updateManuals(index, indexMan) {
	setTimeout(() => {
		this.model.languages[index].manuals
			= removeItemFromArrayByIndex(indexMan, this.model.languages[index].manuals);
	}, 500);
}

function validations() {
	const validation = {
		model: {
			code: {
				required,
			},
			codeProject: {
				required,
			},
			codeWeb: {
				required,
			},
			languages: {
				required,
			},
			newTitle: {
				en: {
					title: {
						required: requiredIf(() =>
							Object.keys(this.newTitle).find(k => k === 'en') && this.model.flagNew),
					},
				},
				es: {
					title: {
						required: requiredIf(() =>
							Object.keys(this.newTitle).find(k => k === 'es') && this.model.flagNew),
					},
				},
			},
			pathIcon: {
				required,
			},
			position: {
				required,
			},
		},
	};
	return validation;
}

function data() {
	return {
		languagesByProject: {},
		loading: false,
		model: {
			code: '',
			codeProject: '',
			codeWeb: '',
			flagNew: false,
			hotKeys: [],
			languages: {},
			newTitle: {},
			numFragment: null,
			pathIcon: '',
			position: null,
		},
		newTitle: {},
	};
}

export default {
	name: 'action-form',
	created,
	components: {
		UploadImage,
	},
	computed: {
		buttonDisabled,
		flagNewName,
		languagesEmpty,
		mode,
	},
	data,
	methods: {
		closeModal,
		getImage,
		getManual,
		loadLanguages,
		removeKey,
		submitForm,
		updateManuals,
		verifyManualsExist,
	},
	props: {
		actionId: {
			type: [Number, String],
		},
		codeProject: {
			type: String,
			required: true,
		},
	},
	validations,
};
</script>



// WEBPACK FOOTER //
// src/components/actions/action-form.vue